import { Pipe, PipeTransform } from '@angular/core';
import { DocumentStatus } from '@workspaces/models/documents';

@Pipe({
  name: 'documentStatusColor',
  standalone: true,
  pure: true
})
export class DocumentStatusColorPipe implements PipeTransform {
  transform(value: DocumentStatus | null | undefined): string {
    if (!value) {
      return '';
    }

    switch (value.toUpperCase()) {
      case 'FAILED':
        return 'doc-error';
      case 'WAITING_FOR_UPLOAD':
        return 'doc-warning';
      case 'PROCESSING':
        return 'doc-processing';
      case 'PROCESSED':
        return 'doc-success';
      default:
        return '';
    }
  }
}
